import { render } from "./SettingsWorkspaceAddOrEdit.vue?vue&type=template&id=9142efe4&scoped=true"
import script from "./SettingsWorkspaceAddOrEdit.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspaceAddOrEdit.vue?vue&type=script&lang=js"

import "./SettingsWorkspaceAddOrEdit.vue?vue&type=style&index=0&id=9142efe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9142efe4"]])

export default __exports__